/** Hide on scroll. */
{
	const hide_on_scroll_elements = document.querySelectorAll(".hide-on-scroll");
	if (hide_on_scroll_elements instanceof NodeList) {
		let scroll_y = window.scrollY;
		window.addEventListener("scroll", (_) => {
			hide_on_scroll_elements.forEach((hide_on_scroll) => {
				if (window.scrollY > scroll_y) {
					hide_on_scroll.classList.add("hide");
				} else {
					hide_on_scroll.classList.remove("hide");
				}
			});
			scroll_y = window.scrollY;
		});
	}
}
